export default "__VITE_ASSET__13580ab8__"